import ProfileCVService from "@services/profile-cv-service";
import { getSingleInstanceByElement, getSingleInstanceByName, initialiseComponents } from "../../../core";
import Component from "../../component.abstract";
import CvUploader from "../../cv-uploader/cv-uploader";
import { notifyFromAlert, notifyUser } from "../../helpers/notifs";
import SimpleSelect, { SimpleSelectItem } from "../../inputs/simple-select/simple-select";
import SimpleProgress from "../../simple-progress/simple-progress";
import ProfileInformations from "../informations/profile-informations";

interface ProfileCvProps {
    url: string;
}

export default class ProfileCv extends Component {
    private url: string;
    private data: any;
    private toggle: HTMLInputElement;
    private profileInformations: ProfileInformations;
    private defaultCvSelect: SimpleSelect;
    private isDefaultCvSelected = false;
    private downloadDefaultButton: HTMLElement;
    private removeButton: HTMLElement;
    private uploadButton: CvUploader;
    private uploadButtonLabel: HTMLElement;
    private cvList: HTMLElement;

    constructor(private props: ProfileCvProps, element: HTMLElement) {
        super(props, element);
        this.props.url ? this.url = this.props.url : undefined;
    }
    mounted(): void {
         this.injectTemplate();
         this.toggle = this.element.querySelector<HTMLInputElement>("#visible2");
         this.profileInformations = getSingleInstanceByName("ProfileInformations");
        this.toggle.checked =  this.profileInformations.visibleInput.checked;
        // Listen to changes from the other toggle
        PubSub.subscribe("profileinformation.toggled", (msg: string, value:boolean) => {
            this.toggle.checked = value;
        })

        this.defaultCvSelect = getSingleInstanceByElement("SimpleSelect", this.element.querySelector("#defaultCv"))
        PubSub.subscribe("simple-select.selected", (msg:string, data:any) => {
            if(data.instance.getElement() === this.defaultCvSelect.getElement()) {
                 // Do not respond to the first "select" call which is a programatic call to set the component default selected option
                 // TODO check if still true
                if(this.isDefaultCvSelected) {
                    this.handleDefaultCv(this.downloadDefaultButton, data.value)
                } else {
                    this.isDefaultCvSelected = true;
                }
            }
        })
        this.uploadButton = getSingleInstanceByElement("CvUploader", this.element.querySelector("#rjupload"));
        this.uploadButtonLabel = this.element.querySelector('[data-rjupload-label]'); 

        PubSub.subscribe("upload-cv-done", () => {
            this.addCv();
        })

        PubSub.subscribe("upload-cv-error.errormodal", (eventName: string, responseMessage: string) => {
            let message: string = responseMessage ? responseMessage : undefined;
            if (!this.uploadButton.validFileType()){
                message = (<string>this.uploadButton.labels.msgExtension)
            }
            if (!this.uploadButton.validFileSize()) {
                message = (<string>this.uploadButton.labels.msgMaxsize)
            }
            this.displayError(message);
        })
        this.toggle.addEventListener("change", () => {
            PubSub.publish("profilecv.toggled", this.toggle.checked);
        })

        this.downloadDefaultButton = this.element.querySelector(".default-cv-download");
        this.removeButton = this.element.querySelector(".remove-cv");
        this.cvList = this.element.querySelector(".cv-list");

        this.removeButton.addEventListener("click", () => {
            this.removeButton.classList.toggle("opened");
        });

        if (this.url) {
            this.call();
        }

    }
    setUrl(newurl:string):void {
        this.url = newurl;
    }
    getUrl():string {
        return this.url;
    }
    call():void {
        const service = new ProfileCVService(this.url);

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message)
        });

        service.get((response:any) => {
            this.data = response;
            this.setFields();
            if (this.data.uploaderParams) {
                this.setUploader();
            }
            //Add tracking on load
            if (this.data.trackingsLoad && this.data.trackingsLoad.length) {
                const trackingsLoad = this.data.trackingsLoad[0];
                if (this.data.resumes.length >= 1) {
                    trackingsLoad.typePage = trackingsLoad.typePage + "-nonVide"
                } else {
                    trackingsLoad.typePage = trackingsLoad.typePage + "-vide"
                }
                window.dataLayer.push(trackingsLoad);
            }
        });

    }
    handleDefaultCv(button: HTMLElement, value: string):void {
        this.defaultCv(value);

        for (let i = 0; i < this.data.resumes.length; i++) {
            if (this.data.resumes[i].id === parseInt(value)) {
                // Update download button URL
                button.setAttribute("href", this.data.resumes[i].url);

                break;
            }
        }
    }
    addCv():void {
       const progressButtonInstance: SimpleProgress = getSingleInstanceByElement("SimpleProgress", this.uploadButtonLabel)
        progressButtonInstance.start();
        const inputkey = document.querySelector<HTMLInputElement>("[name=UploaderKey]").value;
        const service = new ProfileCVService(this.url);
        const data = {
            "uploaderKey": inputkey
        }

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message);
            progressButtonInstance.stop();
        });

        service.post(data, (response:any) => {
            notifyFromAlert({
                "Icon": 0,
                "Message": response.message,
                "AnalyticsTrackings": "",
                "sticky": true
            }, true)
            this.data.resumes = response.resumes;
            this.data.uploaderParams.uploaderKey = inputkey;
                                
            this.profileInformations.setData(response.infosProfil);
            this.setUploader();
            this.setFields();
            this.profileInformations.displayResults();
            this.profileInformations.initSearchLabels();
            this.profileInformations.setCompletion();

            //Add tracking event on upload resume
            window.dataLayer.push(this.data.trackingsClick[0])

            //Add tracking event on resume success upload
            const uploadResumeComplete = document.querySelector<HTMLElement>(".notification-content-text > span")
            if (uploadResumeComplete.innerText.includes("CV bien reçu")) {
                window.dataLayer.push(this.data.trackingsClick[1])
            }
            progressButtonInstance.stop();
        });
    }
    setFields():void {
        this.element.classList.remove("haveCv", "empty");
        if (this.data.resumes.length) {
            this.element.classList.add("haveCv");
        } else {
            this.element.classList.add("empty");
            this.toggle.checked = false;
            this.element.classList.remove('pending');
            return;
        }

        const selectedCv = this.data.resumes.filter((resume:any) => {
            return resume.isDefaultResume;
        });
        this.downloadDefaultButton.setAttribute("href", selectedCv[0].url);
        this.isDefaultCvSelected = false;
        this.defaultCvSelect.updateItems(this.data.resumes.map((resume:any):SimpleSelectItem => {
            return {
                "label": resume.fileName,
                "uri": resume.id
            };
        }));
        this.defaultCvSelect.selectItem(selectedCv[0].id.toString());

        let li, span, svg;
        this.cvList.textContent = "";
        for (let i = 0; i < this.data.resumes.length; i++) {
            // Set select fields
            if (this.data.resumes[i].default === true) {
                this.defaultCvSelect.selectItem(this.data.resumes[i].id);
            }

            // Add CVs in list
            li = document.createElement("li");
            li.setAttribute("data-value", this.data.resumes[i].id);

            span = document.createElement("span");
            span.innerText = this.data.resumes[i].fileName;
            li.appendChild(span);

            const svgns = "http://www.w3.org/2000/svg";
            svg = document.createElementNS(svgns, "svg");
            svg.setAttribute("data-load-url", "../img/svg/close0.svg");
            li.appendChild(svg);

            li.addEventListener("click", (event) => {
                this.handleRemoveCv(<HTMLElement>event.currentTarget);
            });

            this.cvList.appendChild(li);
        }

        if(this.profileInformations.getData().isReadyCvTk) {
            this.toggle.removeAttribute("disabled");
        } else {
            this.toggle.setAttribute("disabled", "");
        }

        initialiseComponents();
        this.element.classList.remove('pending');
    }
    setUploader():void {
        const uploader = this.element.querySelector("#rjupload");
        const uploaderInstance: CvUploader = getSingleInstanceByElement("CvUploader", <HTMLElement>uploader);
        let params:any;
        try {
            params = JSON.parse(uploader.getAttribute("data-rjupload"));

            if (this.data.uploaderParams.extensions) {
                params.extension = this.data.uploaderParams.extensions;
                uploaderInstance.setExtension(params.extension);
                
                // Set the "accept" attribute for cv extensions, dynamically on the data provided by the API rather than hard in the html template
                uploader.setAttribute("accept", params.extension);
            }
    
            if (this.data.uploaderParams.maxSize) {
                params.maxsize = this.data.uploaderParams.maxSize;
                uploaderInstance.setMaxsize(params.maxsize)
            }
    
            if (this.data.uploaderParams.uploaderApp) {
                params.uploaderApp = this.data.uploaderParams.uploaderApp;
                uploaderInstance.setApp(params.uploaderApp);
            }
            if(this.data.uploaderParams.uploaderKey) {
                params.uploaderKey = this.data.uploaderParams.uploaderKey;
                uploaderInstance.setKey(params.uploaderKey);
            }
    
            if (this.data.uploaderParams.uploaderType) {
                params.uploaderType = this.data.uploaderParams.uploaderType;
                 uploaderInstance.setType(params.uploaderType);
            }
    
            if (this.data.uploaderParams.url) {
                params.url = this.data.uploaderParams.url;
                uploaderInstance.setUrl(params.url);
            }
    
            uploader.setAttribute("data-rjupload", JSON.stringify(params));
           
        // eslint-disable-next-line no-empty
        } catch(e) {}
    }
    handleRemoveCv(li: HTMLElement):void {
        if(parseInt(li.getAttribute("data-value")) === this.getDefaultCv()[0].id) {
            notifyUser({
                "title": "Êtes vous sûr de vouloir supprimer votre CV ?",
                "messages": [
                    'Le CV "' + li.innerText + 
                    '" est actuellement visible auprès des recruteurs qui recherchent dans notre base candidats. ' +
                    'Il serait préférable de modifier votre CV visible auprès des recruteurs puis de supprimer "' + li.innerText + 
                    '" ensuite.'],
                "okButton": "Supprimer",
                "okCallback": () => {
                    this.removeCv(li.getAttribute("data-value"));
                },
                "cancelButton": "Annuler"
            });
        } else {
            this.removeCv(li.getAttribute("data-value"));
        }
    }
    getDefaultCv():any {
        const defaultCv = this.data.resumes.filter(function(resume:any) {
            return resume.isDefaultResume === true;
        });

        return defaultCv;
    }
    defaultCv(id:string):void {
         const service = new ProfileCVService(this.url);
         const data = {
            "idFile": id
        }

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message);
        });

        service.put(data, (response:any) => {
            this.data.resumes = response.resumes;
        });
    }
    removeCv(id:string):void {
        this.cvList.classList.add("disabled");

        //Add tracking event on cv delete
        window.dataLayer.push(this.data.resumes[0].trackingsClick[0])

        const service = new ProfileCVService(this.url);
        const data = {
            "idFile": id
        }

        service.setErrorHandler((error:any) => {
            let message: string;
            if(error?.Message) {
                message = error.Message;
            }
            this.displayError(message);
        });

        service.delete(data, (response:any) => {
            this.data.resumes = response.resumes;
            this.setFields();
            this.cvList.classList.remove("disabled");
            notifyFromAlert({
                "Icon": 0,
                "Message": response.message,
                "AnalyticsTrackings": "",
                "sticky": true
            }, true);

             this.profileInformations.setData(response.infosProfil);
             this.profileInformations.displayResults();
             this.profileInformations.initSearchLabels();
             this.profileInformations.setCompletion();
        });
    }

    displayError(message?: string):void {
        notifyFromAlert({
            "Icon": 2,
            "Message": message ? message : "Aïe, une erreur est survenue, rechargez la page et réessayez.",
            "AnalyticsTrackings": "",
            "sticky": true
        }, true);
    }
}